<template>
  <div class="book-reader">
    <Header />

    <button class="btn-back" @click="$router.go(-1)">
      ← Voltar
    </button>

    <div class="reader-container" v-show="!loading && pdfUrl">
      <div class="book-wrapper">
        <div id="book" class="flip-book">
          <!-- Pages will be injected here -->
        </div>
      </div>
      <div class="controls" v-if="pageFlip">
        <button class="btn-control" @click="pageFlip.flipPrev()">Anterior</button>
        <span class="page-info">
          Página {{ currentPage + 1 }} de {{ totalPages }}
        </span>
        <button class="btn-control" @click="pageFlip.flipNext()">Próxima</button>
      </div>
    </div>

    <div v-if="loading" class="loading-state">
      <div class="spinner"></div>
      <p>Preparando seu livro em 3D...</p>
    </div>

    <div v-else-if="!pdfUrl && !loading" class="error-state">
      Livro não encontrado ou não disponível.
    </div>

    <BookModal v-if="showModal" :book="book" @close="showModal = false" />
  </div>
</template>

<script>
import request, { Url } from '../router/request'
import Header from '@/components/Header.vue'
import BookModal from '@/components/BookModal.vue'
import '@/styles/Book.css'
import * as pdfjsLib from 'pdfjs-dist'
import { PageFlip } from 'page-flip'

// Configuração do Worker do PDF.js
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`

export default {
  name: 'BookView',
  components: {
    Header,
    BookModal
  },
  data() {
    return {
      pdfUrl: '',
      showModal: false,
      book: {
        amd: this.$route.query.amd,
        hash: this.$route.query.hash
      },
      loading: true,
      pageFlip: null,
      currentPage: 0,
      totalPages: 0,
      pdfDoc: null
    }
  },
  methods: {
    async viewBook() {
      const { amd, hash } = this.book;

      if (!amd || !hash) {
        alert('Parâmetros ausentes para carregar o PDF.');
        this.loading = false;
        return;
      }

      console.log('Preparando PDF com:', { amd, hash });

      try {
        const response = await request.post('/arquivo/prepararDownload', {
          ano_mes_dia_arq: amd,
          hash_arquivo: hash
        });
        
        if (response.data && response.data.hash) {
          this.pdfUrl = `${Url}/arquivo/download?hash=${response.data.hash}`;
          await this.renderPdfToBook();
        } else {
          alert('Erro: o PDF não foi preparado corretamente.');
          this.loading = false;
        }
      } catch (error) {
        console.error('Erro ao preparar o PDF:', error);
        alert('Erro ao preparar o PDF. Verifique os dados ou tente novamente.');
        this.loading = false;
      }
    },
    async renderPdfToBook() {
      try {
        const loadingTask = pdfjsLib.getDocument(this.pdfUrl);
        this.pdfDoc = await loadingTask.promise;
        this.totalPages = this.pdfDoc.numPages;

        const bookElement = document.getElementById('book');
        bookElement.innerHTML = ''; 

        // Create empty DOM pages
        for (let pageNum = 1; pageNum <= this.totalPages; pageNum++) {
          const div = document.createElement('div');
          div.className = 'page';
          div.dataset.page = pageNum;
          bookElement.appendChild(div);
        }

        this.pageFlip = new PageFlip(bookElement, {
          width: 550, 
          height: 733, 
          size: 'stretch', 
          minWidth: 315,
          maxWidth: 1000,
          minHeight: 420,
          maxHeight: 1350,
          maxShadowOpacity: 0.5,
          showCover: true,
          mobileScrollSupport: true
        });

        this.pageFlip.loadFromHTML(document.querySelectorAll('.page'));

        this.pageFlip.on('flip', (e) => {
          this.currentPage = e.data;
          this.renderPagesAround(this.currentPage);
        });
        
        this.loading = false;
        // Render initial pages
        this.renderPagesAround(0);
      } catch (err) {
        console.error('Error rendering PDF to flipbook:', err);
        this.loading = false;
      }
    },
    async renderPagesAround(currentIndex) {
      // index is 0-based, pageNum is 1-based
      const indicesToRender = [
          currentIndex - 2, currentIndex - 1, 
          currentIndex, currentIndex + 1, 
          currentIndex + 2, currentIndex + 3
      ];
      
      for (let i of indicesToRender) {
          if (i >= 0 && i < this.totalPages) {
              this.renderSinglePage(i + 1);
          }
      }
    },
    async renderSinglePage(pageNum) {
      const pageDiv = document.querySelector(`.page[data-page="${pageNum}"]`);
      if (!pageDiv || pageDiv.hasChildNodes()) return; // Already rendered or not found

      try {
        const page = await this.pdfDoc.getPage(pageNum);
        // Using a scale that keeps quality decent but doesn't blow up memory
        const viewport = page.getViewport({ scale: 1.5 });

        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        
        // CSS to ensure the canvas covers the page area properly
        canvas.style.width = '100%';
        canvas.style.height = '100%';
        canvas.style.objectFit = 'contain';
        canvas.style.backgroundColor = '#fff';

        await page.render({
          canvasContext: context,
          viewport: viewport
        }).promise;

        pageDiv.appendChild(canvas);
      } catch (err) {
        console.error(`Error rendering page ${pageNum}:`, err);
      }
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.viewBook();
  },
  beforeUnmount() {
    if (this.pageFlip) {
      this.pageFlip.destroy();
    }
  }
}
</script>
